import { useEffect, useRef, useState } from "react";
import { applyTheme, getCompanyTheme } from "../../services/api/themeHandler";
import CustomizeDashboard from "../CustomizeDashboard";
import Modal from "../Modal";
import { ThemePayloadProps } from "../../pages/DashboardSetup";
import { errorHandler, localStorageHandler, submitBrandingHandler } from "../../utils/helpers";
import { useGlobalContext } from "../../context/GlobalContext";
import { CONSTANTS } from "../../constants/Constants";
import { useToastContext } from "../../context/ToastContext";

interface CustomizeModalProps {
  setIsModifyDashboardModalOpen: (isOpen: boolean) => void
}
const CustomizeModal = ({
  setIsModifyDashboardModalOpen
}: CustomizeModalProps) => {
  const [themePayload, setThemePayload] = useState<ThemePayloadProps>({
    PrimaryColor: CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR,
    SecondaryColor: CONSTANTS.APP_DEFAULT_COLORS.SECONDARY_COLOR,
    TertiaryColor: CONSTANTS.APP_DEFAULT_COLORS.TERTIARY_COLOR,
    CompanyLogo: null
  })
  const { user, setUser, isLoading, setIsLoading } = useGlobalContext()
  const {showToast} = useToastContext()
  const fileInputRef = useRef<HTMLInputElement>(null);

  const themeChangeHandler = (e: Event) => {
    let target = e.target as HTMLInputElement
    let name = target.name
    let value = target.value
    if (target.type === "file" && target.files) {
      setThemePayload({ ...themePayload, CompanyLogo: target?.files[0] });
    } else if (target.ariaLabel === "cross") {
      setThemePayload({ ...themePayload, CompanyLogo: null })
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } else {
      setThemePayload({ ...themePayload, [name]: value })
    }
  }

  useEffect(() => {
    const fetchCompanyTheme = async () => {
      try {
        const res = await getCompanyTheme();
        if (res?.success && res.data) {
          const themeColors = res.data;
          setThemePayload({
            ...themePayload,
            PrimaryColor: themeColors.primaryColor || CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR,
            SecondaryColor: themeColors.secondaryColor || CONSTANTS.APP_DEFAULT_COLORS.SECONDARY_COLOR,
            TertiaryColor: themeColors.tertiaryColor || CONSTANTS.APP_DEFAULT_COLORS.TERTIARY_COLOR,
          })
        }
      } catch (e) {
        console.log(e);
      }
    }
    fetchCompanyTheme();
    //eslint-disable-next-line
  }, []);

  const continueHandler = async () => {
    try {
      setIsLoading(true)
      let response: any = await submitBrandingHandler(themePayload, true)
      if (response?.data?.success) {
        applyTheme({
          primary: response.data.primaryColor,
          secondary: response.data.secondaryColor,
          tertiary: response.data.tertiaryColor
        })
        localStorageHandler("set", CONSTANTS.LOCAL_STORAGE_KEYS.USER_TXT, { ...user, user: { ...user?.user, companyLogo: response?.data?.data?.logoUrl }})
        setUser({ ...user, user: { ...user?.user, companyLogo: response?.data?.data?.logoUrl } })
        window.location.reload()
      }
      setIsLoading(false)
    } catch (e: any) {
      let error = await errorHandler(e)
      showToast(error, "error")
      setIsLoading(false)
    }

  }
  return (
    <Modal modal_handler={setIsModifyDashboardModalOpen} other_classes="w-fit pt-0" showBtns={false}>
      <CustomizeDashboard
        skipHandler={() => setIsModifyDashboardModalOpen(false)}
        themeChangeHandler={themeChangeHandler}
        continueHandler={continueHandler}
        themePayload={themePayload}
        isLoading={isLoading}
        reference={fileInputRef}
      />
    </Modal>
  );
};

export default CustomizeModal;
